import { FC, PropsWithChildren } from 'react'
import { cn } from '@wellesley/ui'
import useProfile from 'hooks/useProfile'
import PopupContent from './PopupContent'
import { Handlers } from './types'
import { FloatingHoverCard } from '../FloatingHoverCard'

export type UserInfoPopupProps = PropsWithChildren &
  Handlers & {
    canShow?: boolean
    className?: string
    hideFollowButton?: boolean
  } & (
    | {
        userId: string
        allowDeleted?: boolean
      }
    | {
        username: string
      }
  )

const UserInfoPopup: FC<UserInfoPopupProps> = ({
  className,
  canShow = true,
  ...props
}) => {
  return (
    <FloatingHoverCard
      portalId="timeline-feed"
      className="z-[5]"
      trigger={
        <span
          className={cn('max-w-full cursor-default', className)}
          data-testid="infoPopupWrapper"
        >
          {props.children}
        </span>
      }
      disabled={!canShow}
    >
      <PopupContentWrapper {...props} />
    </FloatingHoverCard>
  )
}

const PopupContentWrapper: FC<UserInfoPopupProps> = (props) => {
  const profileProps =
    'userId' in props
      ? { userId: props.userId, allowDeleted: props.allowDeleted }
      : { username: props.username }

  const [user, isOwnProfile, isLoading] = useProfile(profileProps)

  const isChannel = user?.channel

  if (!user || isLoading) return null

  return <PopupContent {...{ user, isOwnProfile, isChannel }} {...props} />
}

export default UserInfoPopup
